// extracted by mini-css-extract-plugin
export default {"stickableMenu":"RequisitesPage_stickableMenu__ic-T-","placeHolderShimmer":"RequisitesPage_placeHolderShimmer__jsloe"};